import { defineMessages } from "react-intl";

export default defineMessages({
  notary: {
    id: "548bf7cb-e3ad-4694-8a1d-3cdf6c30517a",
    defaultMessage: "notary",
  },
  notaryPublic: {
    id: "493c946a-c4f1-463d-85dc-79918ab99978",
    defaultMessage: "notary",
  },
  verificationMethod: {
    id: "c3813795-554c-46ab-802b-50b599b5a038",
    defaultMessage: "ID Validation",
  },

  // Transaction Details Modal
  signingType: {
    id: "47b1f07a-d336-4328-b06d-948d5ddddb12",
    defaultMessage: "Agent Act",
  },
  transactionDetails: {
    id: "b42b8bf7-4296-4548-9f40-f225b5078f36",
    defaultMessage: "Transaction Details",
  },

  // Notary Portal
  signingDocument: {
    id: "67240ee4-ba9e-4596-9166-b27a80f6de71",
    defaultMessage: "Signing Document",
  },

  // Business Portal
  documentCompleteHistoryMessage: {
    id: "b1dc39c5-75eb-47cc-a6cf-d936f6d2bb45",
    defaultMessage: "Identity Confirmation Complete",
  },
  businessSetupUploadMessage: {
    id: "20248bd2-4ef1-4576-93ab-55911767e51c",
    defaultMessage: "{upload} the document you need to have signed",
  },
  businessSetupReceiveMessage: {
    id: "136a7b06-a644-49d8-965d-4ef55d91b852",
    defaultMessage: "{receive} your signed documents automatically",
  },
  tryTemplatesModalHeader: {
    id: "cd39d887-aa63-40e2-a55b-d141a423217f",
    defaultMessage: "eSign request sent!",
  },

  // Signer Portal
  signerDetailsTipWellContent: {
    id: "5ebd09a9-e102-4718-b9e1-933d0452e06e",
    defaultMessage:
      "Some personal information is required in order to verify your identity. We only use this information to perform a legally compliant identity confirmation, and never share or sell it.",
  },
  designationText: {
    id: "06da6bad-d788-499e-89a0-f518d30d2d65",
    defaultMessage:
      "You have {totalDesignations} {totalDesignations, plural, one {field} other {fields}} to fill in",
  },
  signatureNoteTitle: {
    id: "0357d24a-d6d8-4317-b598-e88479f8933a",
    defaultMessage: "Signatures are applied during the video call",
  },
  signatureNoteText: {
    id: "a372159c-22d4-4f99-b4b5-5ad261367bd3",
    defaultMessage: "You will be connected after you verify your identity.",
  },
  annotatableTitle: {
    id: "1e551801-8b32-41a5-a8fa-6723b928aa00",
    defaultMessage: "Prepare Document Forms Before Video Meeting",
  },
  nonannotatableTitle: {
    id: "419b691e-67a2-414f-b5b1-a8489960482a",
    defaultMessage: "Review Document Forms Before Video Meeting",
  },
  completeReview: {
    id: "cece7dab-77c1-4072-b1d8-aae3efea54ad",
    defaultMessage: "Complete Review",
  },
  continuePrepare: {
    id: "b92646fb-4c31-4d32-bcdd-e7c6ff58da95",
    defaultMessage: "Continue",
  },
  disclaimerText: {
    id: "2a15331b-86c3-4189-b152-b0c59c87d948",
    defaultMessage:
      "Signatures will be applied during the live video call. You will be connected in the last step.",
  },
  techCheckExplainer: {
    id: "44cefae6-588b-4eac-83cc-ef8b816eb781",
    defaultMessage:
      "A built-in camera or connected webcam, microphone, speakers or headphones, and a quality internet connection are required to ensure a successful video call with a notary.",
  },
  techCheckExplainerV2: {
    id: "e6dba775-2792-4ab5-bf70-d13fdb8a2ce1",
    defaultMessage:
      "A built-in camera or connected webcam, microphone, speakers or headphones, and a quality internet connection are required to ensure a successful video call with a notary.",
  },
  transactionIsComplete: {
    id: "0f42bfd2-1bc0-4a5c-963d-61fb36b2b0d8",
    defaultMessage: "Your signing is complete!",
  },
  signerEnterPaymentDetails: {
    id: "37755dea-82f4-409b-b942-0eaa1f6f3d0e",
    defaultMessage:
      "Please enter your payment details to access {totalCount, plural, one {the completed document} other {completed documents}}.",
  },
  transactionCustomPriceStartsAt: {
    id: "5839136b-d8d1-4995-afdb-c5aea26f18fc",
    defaultMessage: "This transaction starts at {initialPrice}.",
  },
  transactionBasePriceStartsAt: {
    id: "88155825-f047-4a1d-8894-df4f6e53d0be",
    defaultMessage:
      "This transaction starts at {initialPrice}. Additional signed documents cost {esignedDocPrice}.",
  },
  checkingConnection: {
    id: "6b5c8741-fc9c-44d6-8d6b-0c29e1b38806",
    defaultMessage:
      "Checking your internet connection to ensure a quality notary video call. This test will take a few seconds.",
  },
  startAVideoCallWithNotary: {
    id: "3300b3d6-e2ee-4c75-8937-6ed35ccccfb1",
    defaultMessage: "Up next: Join the notary meeting",
  },
  connectingWithNotary: {
    id: "e25c5984-5513-4f20-a500-fa6a372ec941",
    defaultMessage: "Finding the next available trusted referee...",
  },
  transactionPaidForBy: {
    id: "8b1df217-fae4-4a9b-bafe-e8755c9b1918",
    defaultMessage: "{organizationName} is paying for this transaction.",
  },
  transactionMayBeBilled: {
    id: "2d39f2a4-0bd8-44c7-be81-936576fa3bf0",
    defaultMessage:
      "{organizationName} won't be collecting a payment during the session, but you may be billed afterward.",
  },
  signerSessionExpired: {
    id: "72cfe3fb-b2bd-4e04-970c-9ca2919789d8",
    defaultMessage: "Please re-enter your information to continue.",
  },
  callWillBeRecorded: {
    id: "6f14d3c2-c30e-4cc8-857e-64c982d856da",
    defaultMessage:
      "Audio and video will be recorded during the meeting as proof of identity confirmation.",
  },
  notarizePlatformMessage: {
    id: "e0f0b5bc-202d-42ea-9166-1d02e4022f75",
    defaultMessage:
      "Notarize connects you by video with a notary to perform secure online identity confirmation — no matter where you're located. {learnMore}",
  },
  handleTransactionSentWelcome: {
    id: "49d556ed-d936-4505-a9b5-005c0c4b8280",
    defaultMessage:
      "Welcome to {companyName}! {organizationName} has sent you {totalCount, plural, one {a document} other {documents}} to sign online",
  },
  handleTransactionGenericWelcome: {
    id: "78c5f29e-defc-4418-822c-f1b45fe8dfd0",
    defaultMessage:
      "Welcome to {companyName}. Get your identity confirmed by a notary online. Anytime.",
  },
  organizationSentDocumentForSigning: {
    id: "554ed3ad-e624-43a3-a518-abc37aa995b6",
    defaultMessage:
      "{organizationName} has sent you {totalCount, plural, one {a document} other {documents}} to sign online.",
  },
  getDocumentsSignedAnytime: {
    id: "c0003c38-f9f3-4873-b08b-946c31083940",
    defaultMessage: "Get your identity confirmed by a notary online. Anytime.",
  },
  connectWithNotary: {
    id: "683d7a81-701c-4a55-b5f2-a5101b51cb82",
    defaultMessage: "{connect} with a notary over live video",
  },
  connectWithNotaryFromDevice: {
    id: "e69c2ae5-4341-40d3-96d2-5a6732ec8fc8",
    defaultMessage: "Connect with a notary over live video from your computer, tablet, or phone.",
  },
  notariesAlwaysOnline: {
    id: "c9d29052-322e-4058-9789-ac16b1c8e9c9",
    defaultMessage: "Notaries{break}always online",
  },
  getItSigned: {
    id: "e63dfcac-0c67-48b3-8396-7353d30e361c",
    defaultMessage: "Want to continue on mobile instead? Text yourself a link.",
  },
  bitLandingDocumentMessage: {
    id: "361b08c3-b837-4463-9910-69ed9442b68b",
    defaultMessage:
      "{organizationName} has sent you {totalCount, plural, one{a document} other{documents}} to review and sign",
  },
  bitLandingExperimentDocumentMessage: {
    id: "6bdd44e1-56cf-4af0-978c-c3472af64791",
    defaultMessage:
      "Verify your identity in a few steps and we'll instantly connect you with a certified notary over video call",
  },
  bitLandingDocumentMessageFreeService: {
    id: "3790c815-e5d9-4eb0-ae34-2de68ee43a6d",
    defaultMessage: "This service will be free for you.",
  },
  bitLandingGetStartedMessage: {
    id: "8ed63380-e1f8-4d7c-ae60-33695eae72c4",
    defaultMessage: "View Documents",
  },
  bitLandingWelcomeSubheader: {
    id: "a4d7c832-b4c0-40dd-acd2-a5e0dc24fa19",
    defaultMessage: "Legally Sign Your Documents Online in Minutes",
  },
  signerShareWithAnyone: {
    id: "5c63925e-afe7-4c95-9df2-e7046cf97d7c",
    defaultMessage: "{share} your completed documents with anyone.",
  },
  signatureAnnotationModalMessage: {
    id: "bf90bc8c-ae53-475e-838d-71678f8be0a6",
    defaultMessage:
      "You will be connected to a notary in the last step, after you verify your identity.",
  },
  guestUploadHeaderV1: {
    id: "2a927260-9cbb-4164-a176-fe01dea0ce91",
    defaultMessage: "Get Started with eSignature",
  },
  guestUploadSubheaderV1: {
    id: "171b7c5a-479c-4ce9-9980-5c1cd03ca6ad",
    defaultMessage: "Sign online for free with Notarize.",
  },
  guestUploadAppDownloadInfo: {
    id: "bd515e83-5418-4395-aaba-ce6c5b28d2cc",
    defaultMessage:
      "Take pictures of your paper document and get your document eSigned using our mobile or tablet app.",
  },
  guestUploadAffiliateTxnAppDownloadInfoWebScan: {
    id: "fc58d17f-edd0-42ff-941a-bef59081658e",
    defaultMessage: "Take pictures of your paper document using your preferred mobile browser.",
  },

  // Verify Portal
  verifyRetrievalResultSuccess: {
    id: "f74f223d-6cdd-4e71-bd26-9dc4b4bfef39",
    defaultMessage: "Success! This document was signed!",
  },
});
